const SCROLL_PARENT_SELECTORS = [
  ".content-wrapper",
  ".main-panel",
  ".page-body-wrapper",
  ".container-scroller"
];

/**
 * Scroll the CPT dashboard view to the top. Handles both window scroll and
 * nested scroll containers used in the mobile app layout.
 */
export const scrollCptDashboardToTop = (anchor) => {
  if (typeof window === "undefined") {
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  SCROLL_PARENT_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.scrollTop = 0;
    });
  });

  if (!anchor) {
    return;
  }

  const anchorElement = typeof anchor === "string" ? document.querySelector(anchor) : anchor;

  if (anchorElement) {
    anchorElement.scrollIntoView({ block: "start", behavior: "auto" });
  }
};
